import {INotificationsCommonWebServiceClient, NotificationModuleDto} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class NotificationModuleResolver implements Resolve<NotificationModuleDto[]> {

  constructor(private notificationsWebService: INotificationsCommonWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    return this.notificationsWebService.getMessageNotificationsModule();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/modal-notification-module/notification-module.resoler.ts